// extracted by mini-css-extract-plugin
export default {"header":"Header_header__2cXVF","logo":"Header_logo__wh4Tf","right-block":"Header_right-block__dWkN0","nav":"Header_nav__MScIo"};